import {Modal} from "react-bootstrap";
import QRCode from "react-qr-code";
import {useContext, useEffect, useState} from "react";
import PrintIcon from '@mui/icons-material/Print';
import {formatCurrency} from "../../common/Utils";
import MDButton from "../../../components/MDButton";
import {CompanyContext} from "../../../lib/CompanyProvider";
import GiftCardBody from "./GiftCardBody";

export default function GiftCardQrCode({giftCard, show, handleClose}) {
  const [context, setContext] = useContext(CompanyContext);

  const [giftCardUrl, setGiftCardUrl] = useState('');
  useEffect(() => {
    setGiftCardUrl(context?.company?.portalUrl + '#/cx/gift-card/' + giftCard?.guid)
  }, [context]);


  const printGiftCard = () => {
    const content = document.getElementById("gift-card").innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; font-size:0.9rem; line-height:0.9rem; }
                                                      p{margin:0; padding:0; line-height:13px; font-size:12px;}
                                                      h1,h2,h3,h4,h5,h6{font-size:14px; margin:0; padding:0; line-height:15px}
                                                      .no-print { display: none !important; }
                                                      body * {
                                                      max-width: 96%
                                                      }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  let giftCardBackgroundStyles = 'background: repeating-linear-gradient(45deg, white 0 10px, #eee 10px 20px)';
  if (giftCard.backgroundImageUrl) {
    giftCardBackgroundStyles = "url('" + giftCard.backgroundImageUrl + "') no-repeat center/cover ";
  }

  return (
    <Modal onHide={handleClose} size={'lg'} fullscreen={true} dialogClassName={'psb-page-overlay'}
           show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Gift Card</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <div id={'gift-card'}>
          <GiftCardBody backgroundStyle={{
            background: giftCardBackgroundStyles
          }}
                        giftCardRecipient={giftCard.giftCardRecipient}
                        giftCardFrom={giftCard.from}
                        giftCardBalance={giftCard.currentBalance}
                        giftCardQrCode={<QRCode
                          size={256}
                          style={{height: "auto", maxWidth: "100%", width: "100%"}}
                          value={giftCardUrl}
                          viewBox={'0 0 256 256'}/>}
                        companyName={context?.company?.companyName}
                        giftCardMessage={giftCard.giftCardMessage}
                        giftCardCode={giftCard.transferCode}
                        giftCardLink={giftCardUrl}/>
        </div>
        <hr/>

        <MDButton type="button" color="primary" size={"small"} className={'my-3 mx-4'} onClick={() => {
          printGiftCard()
        }}>
          <PrintIcon/>&nbsp;Print
        </MDButton>

      </Modal.Body>

      <Modal.Footer>

        <MDButton type="button" color="info" onClick={() => {
          handleClose()
        }}>
          Close
        </MDButton>
      </Modal.Footer>
    </Modal>
  );
}